import { isTauri } from '@heidi/runtime/platform';

import { getNoteGenerationEngineConfig } from '../../config';

/**
 * Browser says no network, or (desktop) the Rust probe has confirmed it — macOS
 * WKWebView pins `navigator.onLine` true, so the atom is the only signal there.
 * `backend_unreachable` is not offline.
 *
 * Only the offline-recording flag arms that probe (`useOfflineConnectivitySync`).
 * With it off the atom stays `'unknown'`, so macOS desktop never classifies
 * offline and falls back to the generic error state.
 */
const isClientOffline = (): boolean =>
  (typeof navigator !== 'undefined' && navigator.onLine === false) ||
  (isTauri() &&
    getNoteGenerationEngineConfig().readOfflineConnectivityState() === 'offline');

/**
 * A network-level failure while the client reports no network. `fetch` rejects
 * with a `TypeError` when the request never completes, and a body read rejects
 * with one when the connection drops mid-stream, after a 200. Anything else —
 * the legacy transport's `FatalError`, or the plain `Error('HTTP 500')` the V2_2
 * transport hands to onError for a non-OK response — means a response arrived,
 * so the network worked.
 */
export const isOfflineStreamFailure = (error: unknown): boolean =>
  error instanceof TypeError && isClientOffline();
